! function(i, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (i = i || self).WechatJSSDK = t()
}(this, (function() {
    var i = ["onMenuShareTimeline", "onMenuShareAppMessage"],
        t = ["wx-open-subscribe", "wx-open-audio"];
    return function() {
        function n(e) {
            if (this instanceof n) {
                this.sdkUrl = "//res.wx.qq.com/open/js/jweixin-1.4.0.js", this.config = e || {}, this.config.customUrl && (this.sdkUrl = this.config.customUrl);
                var s = this.config.jsApiList,
                    r = this.config.openTagList;
                if (!s || s.length <= 0) this.config.jsApiList = i;
                else
                    for (var o = 0, a = i.length; o < a; o++) {
                        var c = i[o];
                        s.indexOf(c) < 0 && s.push(c)
                    }
                if (!r || r.length <= 0) this.config.openTagList = t;
                else
                    for (var u = 0, h = t.length; u < h; u++) {
                        var f = t[u];
                        r.indexOf(f) < 0 && r.push(f)
                    }
                return this.debug = !!this.config.debug, this
            }
            return new n(e)
        }
        var e = n.prototype;
        return e.initialize = function() {
            return this.loadScript()
        }, e.signSignature = function(i) {
            var t = this,
                n = this.config,
                e = i || n,
                s = {
                    debug: this.debug,
                    appId: n.appId,
                    timestamp: e.timestamp || n.timestamp,
                    nonceStr: e.nonceStr || n.nonceStr,
                    signature: e.signature || n.signature,
                    jsApiList: n.jsApiList.slice(0, n.jsApiList.length),
                    openTagList: n.openTagList.slice(0, n.openTagList.length)
                },
                r = this.debug;
            return new Promise((function(i, n) {
                if (!window.wx) return n(new Error("wx js not defined"));
                var e = window.wx;
                t.setOriginWx(), e.config(s), e.ready((function() {
                    console.log("sign signature finished..."), t.setOriginWx(), i(t)
                })), e.error((function(i) {
                    r && alert("sign error: " + JSON.stringify(i)), t.setOriginWx(), n(i)
                }))
            }))
        }, e.loadScript = function() {
            var i = this;
            return new Promise((function(t, n) {
                var e = document.createElement("script");
                e.type = "text/javascript", e.async = !0, e.onload = function() {
                    console.log("Wechat script loaded successfully!"), i.signSignature().then((function(i) {
                        t(i)
                    })).catch((function(i) {
                        n(i)
                    }))
                }, e.onerror = function(t) {
                    console.error("Failed to load wechat script!"), console.error(t), i.debug && alert("Cannot load wechat script!"), n(t)
                };
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(e, s), e.src = i.sdkUrl
            }))
        }, e.shareOnMoment = function(i) {
            return i ? this.callWechatApi("onMenuShareTimeline", i) : this
        }, e.shareOnChat = function(i) {
            return i ? this.callWechatApi("onMenuShareAppMessage", i) : this
        }, e.callWechatApi = function(i, t, n) {
            if (!i) return this;
            var e = this.debug;
            if (this.config.jsApiList.indexOf(i) < 0) return e && alert("the wechat api [" + i + "] you call was not registered, \npls add the api into your [jsApiList] config"), this;
            var s = this.getOriginalWx()[i];
            return s && "function" == typeof s ? (s(t, n), this) : (e && alert("no such api [" + i + "] found!"), this)
        }, e.getOriginalWx = function() {
            return this.wx || window.wx
        }, e.setOriginWx = function() {
            return this.wx || (this.wx = window.wx), this
        }, n
    }()
}));